module.exports = __webpack_public_path__ + "img/enterprise-main04.daf43f3d.jpg";